import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'om-textarea-formly',
  templateUrl: './om-textarea-formly.component.html',
  styleUrls: ['./om-textarea-formly.component.scss'],
})
export class OmTextareaFormlyComponent extends FieldType implements OnInit {

  ngOnInit(): void {
    if (this.props.required) {
      this.formControl.addValidators(Validators.required);
    }
  }

}
